import { render, staticRenderFns } from "./detailBottom.vue?vue&type=template&id=009575e0&scoped=true"
import script from "./detailBottom.vue?vue&type=script&lang=js"
export * from "./detailBottom.vue?vue&type=script&lang=js"
import style0 from "./detailBottom.vue?vue&type=style&index=0&id=009575e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009575e0",
  null
  
)

export default component.exports